import AccountIcon from '@mui/icons-material/ManageAccounts'
import SettingsIcon from '@mui/icons-material/Settings'
import Typography from '@mui/material/Typography'
import { forwardRef } from 'react'
import { AppBar, MenuItemLink, UserMenu, useTranslate } from 'react-admin'
import { makeStyles } from 'tss-react/mui'
import Logo from './Logo'

const useStyles = makeStyles()({
  title: {
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  spacer: {
    flex: 1,
  },
})

const ConfigurationMenu = forwardRef<any, any>((props, ref) => {
  return (
    <MenuItemLink
      ref={ref}
      to='/configuration'
      primaryText='Konfiguration'
      leftIcon={<SettingsIcon />}
      onClick={props.onClick}
      sidebarIsOpen
    />
  )
})

const AccountMenu = forwardRef<any, any>((props, ref) => {
  const translate = useTranslate()
  return (
    <MenuItemLink
      ref={ref}
      to='/account'
      primaryText={translate('account.title')}
      leftIcon={<AccountIcon />}
      onClick={props.onClick}
      sidebarIsOpen
    />
  )
})

const CustomUserMenu = (props: any) => (
  <UserMenu {...props}>
    <AccountMenu />
    <ConfigurationMenu />
  </UserMenu>
)

const CustomAppBar = (props: any) => {
  const { classes } = useStyles()
  return (
    <AppBar {...props} elevation={1} userMenu={<CustomUserMenu />}>
      <Typography variant='h6' color='inherit' className={classes.title} id='react-admin-title' />
      <Logo />
      <span className={classes.spacer} />
    </AppBar>
  )
}

export default CustomAppBar
